module.exports = __webpack_public_path__ + "static/media/leave-requests.d5faed45.jpg";